// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lq-0";
export var assigneeDetails = "_lq-1";
export var assigneeInfo = "_lq-2";
export var dropdownContainer = "_lq-4";
export var dropdownImage = "_lq-5";
export var editAssigneeInfo = "_lq-3";
export var editAssigneeModalContainer = "_lq-6";
export var hidden = "_lq-8";
export var input = "_lq-7";